import { render } from "./PromptCardInput.vue?vue&type=template&id=a2129b44&scoped=true"
import script from "./PromptCardInput.vue?vue&type=script&lang=js"
export * from "./PromptCardInput.vue?vue&type=script&lang=js"

import "./PromptCardInput.vue?vue&type=style&index=0&id=a2129b44&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2129b44"]])

export default __exports__